// import _findIndex from 'lodash/findIndex';
// import _find from 'lodash/find';
import APPCONFIG from '../../constants/Config';
import * as types from '../../constants/ActionTypes';

const initialSettings = APPCONFIG.webSocket;
const intl = (state = initialSettings, action) => {
  // let index;
  // let topic;
  // let newTopics;
  switch (action.type) {
    // WS OPEN
    case types.WS_OPEN:
      return {
        ...state,
        open: true,
      };
    case types.WS_CLOSE:
      return {
        ...state,
        open: false,
      };
    // case types.WS_JOIN_TOPIC:
    //   // Try to find the joined topic in registered topics
    //   index = _findIndex(state.topics, {'topic': action.topic, 'ref': action.ref});
    //   topic = _find(state.topics, {'topic': action.topic, 'ref': action.ref});
    //   if (index >= 0) {
    //     // Topic already registered => empty its payload
    //     newTopics = [...state.topics.slice(0, index), {...topic, payload: null}, ...state.topics.slice(index + 1)];
    //   } else {
    //     // Topic not registered => add it
    //     newTopics = [...state.topics, {topic: action.topic, ref: action.ref, payload: null}];
    //   }
    //   return {
    //     ...state,
    //     topics: newTopics
    //   }
    default:
      return state;
  }
};

export default intl;



// WEBPACK FOOTER //
// ./reducers/webSocket/webSocket.js